__turbopack_context__.v({
  "bentoCard": "DFyYBq_bentoCard",
  "caption": "DFyYBq_caption",
  "imageContainer": "DFyYBq_imageContainer",
  "textContainer": "DFyYBq_textContainer",
  "title": "DFyYBq_title",
});
